module.exports = __webpack_public_path__ + "img/Semaforo1.983f26b3.svg";